import { DATE_AFTER_OP, DATE_BEFORE_OP } from './constants';

export function isDateOp(op: string) {
  return op === DATE_BEFORE_OP || op === DATE_AFTER_OP;
}
